import {
    AmexPayment,
    AmexPaymentRebranding,
    ApplePayPayment,
    ApplePayPaymentRebranding,
    BancontactPayment,
    BancontactPaymentRebranding,
    BoletoPayment,
    BoletoPaymentRebranding,
    DiscoverPayment,
    DiscoverPaymentRebranding,
    EloPayment,
    EloPaymentRebranding,
    GooglePayPayment,
    GooglePayPaymentRebranding,
    HipercardPayment,
    HipercardPaymentRebranding,
    IdealPayment,
    IdealPaymentRebranding,
    MaestroPayment,
    MaestroPaymentRebranding,
    MastercardPayment,
    MastercardPaymentRebranding,
    MonerisPayment,
    MonerisPaymentRebranding,
    Money,
    OxxoPayment,
    PagofacilPayment,
    PagofacilPaymentRebranding,
    PaypalPayment,
    PaypalPaymentRebranding,
    RapipagoPayment,
    RapipagoPaymentRebranding,
    SepaPayment,
    SepaPaymentRebranding,
    SofortPayment,
    SofortPaymentRebranding,
    VisaDebitPayment,
    VisaPayment,
    VisaPaymentRebranding,
} from '@eventbrite/eds-iconography';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { getIsAppRebrandActive } from '../../selectors/app';
import { CheckoutState } from '../../state';
import { PaymentConstraintName } from './enums';

const isAppRebrandActive = getIsAppRebrandActive({} as CheckoutState);
interface PaymentConstraintVariant {
    userString: string | GenericLazyString;
    icon?: React.ReactNode;
}
export const PAYMENT_CONSTRAINT_VARIANTS: Record<
    PaymentConstraintName,
    PaymentConstraintVariant
> = {
    [PaymentConstraintName.ADYEN_POS_PAYMENT]: {
        userString: 'Adyen POS Payment',
    },
    [PaymentConstraintName.AMEX]: {
        userString: 'American Express',
        icon: isAppRebrandActive ? <AmexPaymentRebranding /> : <AmexPayment />,
    },
    [PaymentConstraintName.BRAINTREE_APPLE_PAY]: {
        userString: 'Apple Pay',
        icon: isAppRebrandActive ? (
            <ApplePayPaymentRebranding />
        ) : (
            <ApplePayPayment />
        ),
    },
    [PaymentConstraintName.BRAINTREE_GOOGLE_PAY]: {
        userString: 'Google Pay',
        icon: isAppRebrandActive ? (
            <GooglePayPaymentRebranding />
        ) : (
            <GooglePayPayment />
        ),
    },
    [PaymentConstraintName.BOLETO_BANCARIO]: {
        userString: 'Boleto Bancario',
        icon: isAppRebrandActive ? (
            <BoletoPaymentRebranding />
        ) : (
            <BoletoPayment />
        ),
    },
    [PaymentConstraintName.BARCODE]: {
        userString: gettext('Pay in cash with Rapipago or Pagofacil'),
        icon: isAppRebrandActive ? <Money /> : <Money />,
    },
    [PaymentConstraintName.BRAINTREE_PAYPAL]: {
        userString: 'Paypal',
        icon: isAppRebrandActive ? (
            <PaypalPaymentRebranding />
        ) : (
            <PaypalPayment />
        ),
    },
    [PaymentConstraintName.CREDIT_CARD]: {
        userString: gettext('Credit Card'),
    },
    [PaymentConstraintName.DEBIT_CARD]: {
        userString: gettext('Debit Card'),
    },
    [PaymentConstraintName.DINERS_CLUB]: {
        userString: gettext('Diners Club'),
    },
    [PaymentConstraintName.DISCOVER]: {
        userString: 'Discover',
        icon: isAppRebrandActive ? (
            <DiscoverPaymentRebranding />
        ) : (
            <DiscoverPayment />
        ),
    },
    [PaymentConstraintName.ELO]: {
        userString: 'Elo',
        icon: isAppRebrandActive ? <EloPaymentRebranding /> : <EloPayment />,
    },
    [PaymentConstraintName.HIPERCARD]: {
        userString: 'Hipercard',
        icon: isAppRebrandActive ? (
            <HipercardPaymentRebranding />
        ) : (
            <HipercardPayment />
        ),
    },
    [PaymentConstraintName.IDEAL]: {
        userString: 'iDEAL',
        icon: isAppRebrandActive ? (
            <IdealPaymentRebranding />
        ) : (
            <IdealPayment />
        ),
    },
    [PaymentConstraintName.MAESTRO]: {
        userString: 'Maestro',
        icon: isAppRebrandActive ? (
            <MaestroPaymentRebranding />
        ) : (
            <MaestroPayment />
        ),
    },
    [PaymentConstraintName.MAESTRO_BANCONTACT]: {
        userString: 'Maestro Bancontact',
        icon: isAppRebrandActive ? (
            <BancontactPaymentRebranding />
        ) : (
            <BancontactPayment />
        ),
    },
    [PaymentConstraintName.MASTERCARD]: {
        userString: 'Mastercard',
        icon: isAppRebrandActive ? (
            <MastercardPaymentRebranding />
        ) : (
            <MastercardPayment />
        ),
    },
    [PaymentConstraintName.MERCADO_PAGO]: {
        userString: 'Mercado Pago',
    },
    [PaymentConstraintName.MONERIS]: {
        userString: 'Moneris',
        icon: isAppRebrandActive ? (
            <MonerisPaymentRebranding />
        ) : (
            <MonerisPayment />
        ),
    },
    [PaymentConstraintName.NARANJA]: {
        userString: 'Naranja',
    },
    [PaymentConstraintName.NATIVA]: {
        userString: 'Nativa',
    },
    [PaymentConstraintName.OXXO]: {
        userString: 'OXXO',
        icon: <OxxoPayment />,
    },
    [PaymentConstraintName.PAGOFACIL]: {
        userString: 'Pago Fácil',
        icon: isAppRebrandActive ? (
            <PagofacilPaymentRebranding />
        ) : (
            <PagofacilPayment />
        ),
    },
    [PaymentConstraintName.RAPIPAGO]: {
        userString: 'Rapipago',
        icon: isAppRebrandActive ? (
            <RapipagoPaymentRebranding />
        ) : (
            <RapipagoPayment />
        ),
    },
    [PaymentConstraintName.SEPA_DIRECT_DEBIT]: {
        userString: 'Sepa Direct Debit',
        icon: isAppRebrandActive ? <SepaPaymentRebranding /> : <SepaPayment />,
    },
    [PaymentConstraintName.SOFORT]: {
        userString: 'Sofort',
        icon: isAppRebrandActive ? (
            <SofortPaymentRebranding />
        ) : (
            <SofortPayment />
        ),
    },
    [PaymentConstraintName.VISA]: {
        userString: 'Visa',
        icon: isAppRebrandActive ? <VisaPaymentRebranding /> : <VisaPayment />,
    },
    [PaymentConstraintName.VISA_DEBIT]: {
        userString: gettext('Visa Debit Card'),
        icon: isAppRebrandActive ? <VisaDebitPayment /> : <VisaDebitPayment />,
    },
};
